import { type SidebarFolderHandlers, type SidebarNavSpaceFolder, useToast } from "@design";
import { useTranslation } from "react-i18next";

/** After a drag into or out of a folder: a toast naming the space and where it went, with Undo. */
export function useSpaceMovedToast(
  spaces: ReadonlyArray<{ key: string; name: string }>,
  folders: SidebarNavSpaceFolder[] | undefined,
): NonNullable<SidebarFolderHandlers["onSpaceMoved"]> {
  const { t } = useTranslation("shell", { keyPrefix: "sidebar" });
  const toast = useToast();
  return ({ spaceKey, folderKey, undo }) =>
    toast.success(t("folders.spaceMoved"), {
      description: t("folders.spaceMovedTo", {
        space: spaces.find((sp) => sp.key === spaceKey)?.name ?? "",
        folder: (folderKey && folders?.find((f) => f.key === folderKey)?.name) || t("allSpaces"),
      }),
      action: { label: t("folders.undo"), onClick: undo },
    });
}
